
export class ConsultConnectionDocumentsModel {
    
    DocumentNumber : string;
    ConnectionTypeName : string;
    CountryCode : string;
    DocumentName : string;
    DocumentType : string;
    DocumentConditions : string;
    DocumentFormat : string;
    UrlDocumentFormat : string;
    CreatedBy : string;
    CreatedDate : Date;
    ModifiedBy : string;
    ModifiedDate : Date;

  }
  